import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AttachmentsModule } from '../shared/attachments/attachments.module';
import { SharedAngularMaterialModule } from '../shared/shared-angular-material/shared-angular-material.module';
import { SharedPipesModule } from '../shared/shared-pipes/shared-pipes.module';
import { TranslocoRootModule } from '../transloco-root.module';
import { PatientPortalViewComponent } from './patient-portal-view/patient-portal-view.component';



@NgModule({
  declarations: [PatientPortalViewComponent],
  imports: [
    CommonModule,
    AttachmentsModule,
    SharedAngularMaterialModule,
    TranslocoRootModule,
    SharedPipesModule
  ],
})
export class PatientPortalModule { }
